import React, { ReactElement } from 'react';
import { Route, HashRouter as Router } from 'react-router-dom';
import Home from './pages/home';
import ServiceList from './pages/pile-service-list';

import ApplyToInstall from './pages/apply-to-install';

import Urging from './pages/progress-urging';
import SurveyReport from './pages/survey-report';
import InstallReport from './pages/installing-report';
import AfterSalesService from './pages/after-sales-service';
import MaintenanceResults from './pages/maintenance-results';
import OldInstalling from './pages/apply-previous';
import OldAfterSales from './pages/after-sales-previous';
import SelectServiceOrder from './pages/service-progress';
import InstalledList from './pages/service-status';

import PileInstallation from './pages/pile-installation';
import EvaluationService from './pages/evaluation-service/app';
import AfterSales from './pages/after-sales';
import ServiceHelp from './pages/service-help';
import AfterSalesQuestionnaireSurvey from './pages/after-sale-questionnaire-survey';
import FirstChargeSurvey from './pages/first-charge-questionnaire-survey/app';
import CancelService from './pages/cancel-service/app';
import { initGdp } from '../../utils/gio-report';

const setTitle = title => {
  document.title = title;
};

initGdp()

const App = (): ReactElement => {
  return (
    <Router>
      <Route path="/" exact component={Home} title={'家桩'} />
      <Route
        path="/pile-service-list"
        exact
        component={ServiceList}
        onEnter={setTitle('家桩')}
      />
      <Route
        path="/pile-installation"
        exact
        component={PileInstallation}
        onEnter={setTitle('家桩')}
      />
      <Route
        path="/evaluation-service"
        exact
        component={EvaluationService}
        onEnter={setTitle('家桩')}
      />
      <Route

        path="/apply-to-install"
        exact
        component={ApplyToInstall}
        onEnter={setTitle('家桩')}
      />
      <Route
        path="/urging"
        exact
        component={Urging}
        onEnter={setTitle('家桩')}
      />
      <Route
        path="/survey-report"
        exact
        component={SurveyReport}
        onEnter={setTitle('家桩')}
      />
      <Route
        path="/install-report"
        exact
        component={InstallReport}
        onEnter={setTitle('家桩')}
      />
      <Route
        path="/after-sales-service"
        exact
        component={AfterSalesService}
        onEnter={setTitle('家桩')}
      />
      <Route
        path="/maintenance-results"
        exact
        component={MaintenanceResults}
        onEnter={setTitle('家桩')}
      />
      <Route
        path="/apply-previous"
        exact
        component={OldInstalling}
        onEnter={setTitle('家桩')}
      />
      <Route
        path="/after-sales-previous"
        exact
        component={OldAfterSales}
        onEnter={setTitle('家桩')}
      />
      <Route
        path="/service-progress"
        exact
        component={SelectServiceOrder}
        onEnter={setTitle('家桩')}
      />
      <Route
        path="/service-status"
        exact
        component={InstalledList}
        onEnter={setTitle('家桩')}
      />
      <Route
        path="/after-sales"
        exact
        component={AfterSales}
        onEnter={setTitle('家桩')}
      />
      <Route
        path="/service-help"
        exact
        component={ServiceHelp}
        onEnter={setTitle('家桩')}
      />
      <Route
        path="/after-sale-questionnaire-survey"
        exact
        component={AfterSalesQuestionnaireSurvey}
        onEnter={setTitle('问卷调查填写')}
      />
      <Route
        path="/first-charge-questionnaire-survey"
        exact
        component={FirstChargeSurvey}
        onEnter={setTitle('问卷调查填写')}
      />
      <Route
        path="/cancel-service"
        exact
        component={CancelService}
        onEnter={setTitle('问卷调查填写')}
      />
    </Router>
  );
};

export default App;
